import { render, staticRenderFns } from "./ImgDepotTab.vue?vue&type=template&id=e27aa67e&scoped=true&"
import script from "./ImgDepotTab.vue?vue&type=script&lang=js&"
export * from "./ImgDepotTab.vue?vue&type=script&lang=js&"
import style0 from "./ImgDepotTab.vue?vue&type=style&index=0&id=e27aa67e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27aa67e",
  null
  
)

export default component.exports